export const visit = (vm, at) => {
at({ "en-gb": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} of {{totalBytes}}" }, "fileSizeLimit": "The file can't be larger than {{size}}", "screenCapture": "Screen capture" } } });
};